import type { OneOnOne, EmployeeInfo } from '@momentum/types';

export interface GroupedProfessionalMeeting {
  employeeId: string;
  employeeName: string;
  employeeImageUrl?: string;
  employeeRole: string;
  meetings: OneOnOne[];
}

type EmployeeWithRequiredFields = Pick<
  EmployeeInfo,
  '_id' | 'personalInfo' | 'role'
>;

export const groupProfessionalMeetings = (
  meetings: OneOnOne[],
  allEmployees: EmployeeWithRequiredFields[],
  groupBy: 'employeeId' | 'managerId'
): GroupedProfessionalMeeting[] => {
  if (!meetings || !allEmployees || meetings.length === 0) {
    return [];
  }

  const grouped = meetings.reduce((acc, meeting) => {
    const groupKey = meeting[groupBy];

    if (!acc[groupKey]) {
      const employee = allEmployees.find((e) => e._id === groupKey);

      if (employee) {
        acc[groupKey] = {
          employeeId: groupKey,
          employeeName: `${employee.personalInfo.firstName} ${employee.personalInfo.lastName}`,
          employeeImageUrl: employee.personalInfo.imageUrl,
          employeeRole: employee.role,
          meetings: [],
        };
      }
    }

    acc[groupKey]?.meetings.push(meeting);

    return acc;
  }, {} as Record<string, GroupedProfessionalMeeting>);

  return Object.values(grouped);
};
